import { HowToPayEnum } from 'views/shared/HowToPay/type';
import { MgmtFeeTypeEnum, MgmtViewsEnum } from 'views/shared/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

export interface CurrencyFormater {
  format: (value: number, isNew?: boolean) => string;
}

export interface GbpToTargetCurrency {
  convertAndFormat: (value: number) => string;
  convert: (value: number) => number;
}

export interface CardType {
  id?: string | null;
  name?: string | null;
  last4?: string | null;
  expiryDate?: string | null;
  defaultMitFlag?: boolean | null;
  scheme?: string | null;
}

export type ObjectType = Record<string, unknown>;

export enum PORTAL_DESCRIPTIONS {
  PORTAL_INVEST = 'PORTAL_INVEST',
  PORTAL_BUY_TRADE = 'PORTAL_BUY_TRADE',
  PORTAL_BUY_PORTFOLIO = 'PORTAL_BUY_PORTFOLIO',
  PORTAL_ACCEPTBID_PORTFOLIO = 'PORTAL_ACCEPTBID_PORTFOLIO',
  PORTAL_ACCEPTBID_TRADE = 'PORTAL_ACCEPTBID_TRADE',
}

export enum DeepLinkParamKeys {
  tradeGetProductBylwin18 = 'lwin18',
  navToParam = 'navTo',
  actionParam = 'action',
  dataParam = 'dataParam',
}

export enum DeepLinkAction {
  topUp = 'topUp',
  product = 'product',
}

export enum ChargeMgmtAndSaveCardEnum {
  onChargeCardMgmtFailure = 'onChargeCardMgmtFailure',
  onChargeCardMgmtSuccess = 'onChargeCardMgmtSuccess',
}

export enum BannerTypeEnum {
  COMBINE_FEES = 'combineFees',
  LEGACY = 'legacy',
  MGMT_FEE = 'mgmt_fee',
}

export interface IMgmtHashRef {
  token?: MgmtViewsEnum | null;
  mgmtFeeType?: MgmtFeeTypeEnum;
  howToPay?: HowToPayEnum;
  amount?: number;
  action?: 'pay' | 'addCard';
}

export interface IManageFeeConfig<T = unknown> {
  showBanner: boolean;
  showModal: boolean;
  forceAction: boolean;
  showMore: boolean;
  viewType: MgmtViewsEnum;
  viewData?: T | null;
  bannerType: BannerTypeEnum;
  isLockedOut: boolean;
  annualFeeAmount: number;
  monthlyFeeAmount: number;
  mgmtHashRef: IMgmtHashRef | null;
  selectedFeeAmount: number;
  selectedMgmtFeeType: MgmtFeeTypeEnum;
  hasInitValues?: boolean;
  triggerModel: number;
  accruedFee: number;
  totalDueTodayAnnualFee: number;
  totalDueTodayMonthlyFee: number;
  onNavShowModel: boolean;
  hasMitCard: boolean;
  annualDiscount: number;
  plan: 'annual' | 'monthly';
}
